import { useState, useEffect, useMemo } from 'react';
import { Elements, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { MdError } from 'react-icons/md';
import { Loading } from '../loading';
import { Button } from '../input';
import { useGlobal } from '../../state';
import { stripePublishableKey } from '../../constants';

export function Inner({ onSuccess }) {
  const { fox } = useGlobal();
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { setupIntent, error } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: window.location.href,
      },
      redirect: 'if_required',
    });

    const data = await fox.call('POST', '/api/user/stripe/card', {
      paymentMethodId: setupIntent.payment_method,
    });

    console.log('ok!', data);

    onSuccess();
    setLoading(false);
  };

  if (!stripe || !elements) return <Loading center />;

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <Button loading={loading} disabled={!stripe} type="submit" style={{ marginTop: 16, width: '100%' }}>
        Add Payment Method
      </Button>
    </form>
  );
}

export const AddPaymentMethod = ({ onSuccess }) => {
  const [clientSecret, setClientSecret] = useState();
  const { fox } = useGlobal();

  const stripePromise = useMemo(() => loadStripe(stripePublishableKey), [stripePublishableKey]);

  useEffect(() => {
    if (!fox) {
      return;
    }

    fox.call('POST', '/api/user/stripe/payment-intent').then((data) => {
      setClientSecret(data.clientSecret);
    });
  }, [fox]);

  return (
    <div style={{ width: '100%' }}>
      {clientSecret && (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <Inner onSuccess={onSuccess} />
        </Elements>
      )}
      {!clientSecret && <Loading center />}
    </div>
  );
};
